require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/fn/object/assign.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/fn/object/assign.js
// module chunks = 6